export default "__VITE_ASSET__B8YM5FKs__"